import i18next from 'i18next';

i18next.addResources('es', 'ForgotPassword', {
  title: '¿Olvidaste tu contraseña?',
  success:
    'Si el mail pertenece a un usuario activo en el sistema, le estará llegando un mail de cambio de contraseña.',
  error: 'Error al enviar el correo de recuperación de contraseña...'
});
